import React, {Fragment} from 'react';
import {Stack, Typography} from '@mui/material';
import {FormProvider} from 'react-hook-form';

import operationalCostImg from 'presentation/assets/images/general-security.svg';
import {
	AlertInfo,
	AlertModal,
	CTAButtonFixed,
	MainHeader,
	PasswordInput,
	SubheaderWithSearch,
} from 'presentation/components';
import {ChatRoomsEnum, OperationStateTypesEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useExamAuthorization} from './hooks/useExamAuthorization';
import {StyledCard, StyledContainer, StyledImage, StyledLabel} from './styles';
import {Loading} from 'presentation/components/Loading/Loading';

const {
	title,
	subtitle,
	containerTitle,
	dontHavePass,
	passError,
	primaryButton,
	secondaryButton,
	apiModalErrorText,
	operationalCostImgAlt,
} = translations['pt-br'].others.examAuthorization;

export function ExamAuthorization() {
	const {
		apiModalError,
		operationState,
		setApiModalError,
		handleBack,
		methods,
		handleSubmit,
		handleValidateAuthorizationPassword,
		alertInfoText,
		callChatRoom,
		callChatRoomIsLoading,
		authCodeWatcher,
		isSubmitting,
	} = useExamAuthorization();

	return (
		<Fragment>
			<MainHeader title={title} handleBack={handleBack} />
			<SubheaderWithSearch title={subtitle} />
			<StyledContainer>
				<StyledCard elevation={0}>
					<FormProvider {...methods}>
						<form onSubmit={handleSubmit(handleValidateAuthorizationPassword)}>
							<Stack gap={2}>
								<StyledLabel htmlFor="authCode">{containerTitle}</StyledLabel>
								<PasswordInput
									slotProps={{htmlInput: {maxLength: 10}}}
									hideHelperText
									name="authCode"
									fullWidth
								/>
								{operationState === OperationStateTypesEnum.ERROR ? (
									<AlertInfo.Root severity="error">
										<AlertInfo.Description>
											<Typography>{passError}</Typography>
										</AlertInfo.Description>
									</AlertInfo.Root>
								) : null}
								<AlertInfo.Root>
									<AlertInfo.Title title={dontHavePass} />
									<AlertInfo.Description>
										<Typography>{alertInfoText}</Typography>
										<AlertInfo.Action
											$iconName="arrow-right-filled"
											onClick={async () =>
												await callChatRoom(ChatRoomsEnum.EXAMS)
											}
											disabled={callChatRoomIsLoading}
											endIcon={
												callChatRoomIsLoading ? (
													<Loading size={16} color="inherit" />
												) : null
											}>
											{secondaryButton}
										</AlertInfo.Action>
									</AlertInfo.Description>
								</AlertInfo.Root>
								<CTAButtonFixed.Root sx={{alignSelf: 'end'}}>
									<CTAButtonFixed.Action
										disabled={authCodeWatcher.length === 0 || isSubmitting}
										type="submit"
										endIcon={<Icon name="arrow-right-filled" />}>
										{primaryButton}
									</CTAButtonFixed.Action>
								</CTAButtonFixed.Root>
							</Stack>
						</form>
					</FormProvider>
					<StyledImage>
						<img src={operationalCostImg} alt={operationalCostImgAlt} />
					</StyledImage>
				</StyledCard>

				<AlertModal
					open={apiModalError}
					onClose={() => setApiModalError(false)}
					variant="info"
					headerTitle={apiModalErrorText.title}
					title={apiModalErrorText.subtitle}
					subDescription={apiModalErrorText.description}
				/>
			</StyledContainer>
		</Fragment>
	);
}
